
























































import moment, { unitOfTime } from 'moment';
import Vue, { PropType } from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({})
export default class CDatePicker extends Vue {
  @Prop({ type: String, required: true })
  value: string;

  @Prop({ type: String })
  label: string;

  @Prop({ type: Boolean })
  useButtons: boolean;

  @Prop({ type: String })
  min: string;

  @Prop({ type: String })
  max: string;

  @Prop({ type: String, default: 'mdi-menu-down' })
  icon: string;

  @Prop({ type: String as PropType<'date' | 'month'>, default: 'date' })
  type: 'date' | 'month';

  showPicker = false;

  get disableIncrease(): boolean {
    return (
      this.max &&
      moment(this.max).format('YYYY-MM-DD') <=
        moment(this.value).format('YYYY-MM-DD')
    );
  }

  get disableDecrease(): boolean {
    return (
      this.min &&
      moment(this.min).format('YYYY-MM-DD') >=
        moment(this.value).format('YYYY-MM-DD')
    );
  }

  input(value: string): void {
    this.$emit('input', value);
    this.$nextTick(() => {
      setTimeout(() => {
        this.showPicker = false;
      }, 200);
    });
  }

  increase(value = 1): void {
    const typeMap: Record<string, unitOfTime.DurationConstructor> = {
      date: 'days',
      month: 'months',
    };
    const formatMap = {
      date: 'YYYY/MM/DD',
      month: 'YYYY/MM',
    };
    const newVal = moment(this.value)
      .add(value, typeMap[this.type])
      .format(formatMap[this.type]);
    this.$emit('input', newVal);
  }

  decrease(value = 1): void {
    const typeMap: Record<string, unitOfTime.DurationConstructor> = {
      date: 'days',
      month: 'months',
    };
    const formatMap = {
      date: 'YYYY/MM/DD',
      month: 'YYYY/MM',
    };
    const newVal = moment(this.value)
      .subtract(value, typeMap[this.type])
      .format(formatMap[this.type]);
    this.$emit('input', newVal);
  }
}
